<template>
  <div class="chat-bubble-wrap">
    <button class="chat-bubble agent" :class="{'nudge-message': isBotMessage}" @click="onClickMessage">
      <div v-if="showSender" class="row--agent-block">
        <thumbnail
          :src="avatarUrl"
          size="20px"
          status-indicator-size="10px"
          :username="agentName"
          :status="availabilityStatus"
        />
        <span class="agent--name">{{ agentName }}</span>
        <span class="company--name" v-if="!isBotMessage"> {{ widgetHeading }}</span>
      </div>
      <div class="message-content" v-html="formatMessage(message, false)"></div>
    </button>
  </div>
</template>

<script>
import { IFrameHelper, isEmptyObject } from 'widget/helpers/utils';
import messageFormatterMixin from 'shared/mixins/messageFormatterMixin';
import Thumbnail from 'dashboard/components/widgets/Thumbnail';
import configMixin from '../mixins/configMixin';
import { mapGetters } from 'vuex';
export default {
  name: 'UnreadMessage',
  components: { Thumbnail },
  mixins: [messageFormatterMixin, configMixin],
  props: {
    message: {
      type: String,
      default: '',
    },
    showSender: {
      type: Boolean,
      default: false,
    },
    sender: {
      type: Object,
      default: () => {},
    },
    campaignId: {
      type: Number,
      default: null,
    },
  },
  computed: {
    ...mapGetters({
       activeCampaign: 'campaign/getActiveCampaign',
       hiverConfig: 'hiverConfig/getHiverConfig'
    }),
    widgetHeading() {
      return this.channelConfig.welcomeTitle;
    },
    avatarUrl() {
      // eslint-disable-next-line
      const BotDefaultImage = require('dashboard/assets/images/chatwoot_bot.png');
      const BotImage = (this.isLiveChatFeatureEnabled && this.hiverConfig.bot_icon) ? this.hiverConfig.bot_icon : BotDefaultImage;
      const displayImage = this.useInboxAvatarForBot
        ? this.inboxAvatarUrl
        : BotImage;
      if (this.isSenderExist(this.sender)) {
        const { avatar_url: avatarUrl } = this.sender;
        return this.sender.type === this.hiverDefaultBotType ? BotImage : avatarUrl;
      }
      return displayImage;
    },
    agentName() {
      const hiverBotName = (this.isLiveChatFeatureEnabled && this.hiverConfig.bot_name) ? this.hiverConfig.bot_name : this.$t('UNREAD_VIEW.BOT');
      if (this.isSenderExist(this.sender)) {
        const { available_name: availableName, name } = this.sender;
        const senderName = availableName || name;
        return (senderName === this.hiverDefaultBotName || this.message.sender?.type === this.hiverDefaultBotType || this.sender.type === this.hiverDefaultBotType) ? hiverBotName : senderName;
      }
      return hiverBotName;
    },
    availabilityStatus() {
      if (this.isSenderExist(this.sender)) {
        const { availability_status: availabilityStatus } = this.sender;
        return availabilityStatus;
      }
      return null;
    },
    isBotMessage() {
        return this.agentName === 'Bot' || this.activeCampaign?.message?.includes(this.message);
    }
  },
  methods: {
    isSenderExist(sender) {
      return sender && !isEmptyObject(sender);
    },
    onClickMessage() {
      if (this.campaignId) {
        bus.$emit('on-campaign-view-clicked', this.campaignId);
      } else {
        IFrameHelper.sendMessage({ event: 'unreadMessageClicked' });
        this.$store.dispatch('campaign/campaignMessageClicked', false);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import '~widget/assets/scss/variables.scss';
.chat-bubble {
  max-width: 85%;
  padding: $space-normal;
  cursor: pointer;
}

.row--agent-block {
  align-items: center;
  display: flex;
  text-align: left;
  padding-bottom: $space-small;
  font-size: $font-size-small;
  .agent--name {
    font-weight: $font-weight-medium;
    margin-left: $space-smaller;
  }
  .company--name {
    color: $color-light-gray;
    margin-left: $space-smaller;
  }
}
</style>
